var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomefooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 20,
    height: 20,
    fill: "#c2e5f3",
    stroke: "#143359",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(19300 9796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 24,
    height: 24,
    transform: "translate(-19300 -9796)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-home",
    transform: "translate(-19298 -9794)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M19.268,7.561,12.947,1.239a4.173,4.173,0,0,0-5.893,0L.733,7.561A2.482,2.482,0,0,0,0,9.328v8.181a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5V9.328a2.482,2.482,0,0,0-.733-1.768ZM12.5,18.343h-5V15.064a2.5,2.5,0,1,1,5,0Zm5.833-.833a.833.833,0,0,1-.833.833H14.167V15.064a4.167,4.167,0,1,0-8.333,0v3.278H2.5a.833.833,0,0,1-.833-.833V9.328a.84.84,0,0,1,.244-.589L8.232,2.42a2.507,2.507,0,0,1,3.537,0l6.321,6.322a.841.841,0,0,1,.244.587Z",
    transform: "translate(0 -0.004)",
    fill: "#c2e5f3",
    stroke: "#143359",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomefooter);
export default __webpack_public_path__ + "static/media/Homefooter.f87b8a0dc1697eaf5fe76663832d24df.svg";
export { ForwardRef as ReactComponent };